import React from "react";

import Stack, { Row, StackProps } from "@rui/Stack";

import { SettingSubtitle, SettingTitle } from "./styles";

interface SettingProps extends StackProps {
  title?: string;
  subtitle?: React.ReactNode;
  endIcon?: React.ReactNode;
}

const Setting = ({
  title,
  subtitle,
  children,
  endIcon,
  sx,
  ...props
}: SettingProps) => {
  return (
    <Stack spacing={1} sx={{ px: 1, ...sx }} {...props}>
      {title && (
        <Row spacing={1} variant="left">
          <SettingTitle>{title}</SettingTitle>
          {endIcon}
        </Row>
      )}
      {subtitle && <SettingSubtitle>{subtitle}</SettingSubtitle>}
      {children}
    </Stack>
  );
};

export default Setting;
